import React, { useEffect, useState } from "react";
import { DefaultPopup } from "../../modal";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { hocSinhApi } from "../../../api/hocSinhApi";
import { admissionHelperApi } from "../../../api/admissionHelperApi";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { showNotify } from "../../../helpers/toast";
import { TagBox } from "devextreme-react/tag-box";
import { Button } from "../../buttons";
import CheckBox from "devextreme-react/check-box";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/reducers";
import { TextBox } from "devextreme-react";

type SendBienLaiModalProps = {
    onClose: () => void,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number
}

const SendBienLaiModal: React.FC<SendBienLaiModalProps> = (props) => {
    const [suggest_emails, set_suggest_emails] = useState<{ email: string }[]>([]);
    const [suggest_bcc_emails, set_suggest_bcc_emails] = useState<string>('');

    const [suggest_coso_emails, set_suggest_coso_emails] = useState<{ email: string }[]>([]);
    const [email_to_send_when_finish, set_email_to_send_when_finish] = useState<string[]>([]);
    const [email_coso_to_send_when_finish, set_email_coso_to_send_when_finish] = useState<string[]>([]);

    const [isSaving, SetIsSaving] = useState<boolean>(false);
    const [isShowAttachEmail, SetIsShowAttachEmail] = useState<boolean>(false);
    const { dm_coso_id } = useSelector((x: RootState) => x.common)

    useEffect(() => {
        handleReloadEmail();
        handleReloadEmailCoso();
    }, [props.ts_hocsinh_id]);
    useEffect(() => {
        if (isShowAttachEmail === false) {
            set_email_coso_to_send_when_finish([]);
        }
    }, [isShowAttachEmail]);
    const handleReloadEmail = async () => {
        const res = await hocSinhApi.selectParentEmail(props.ts_hocsinh_id);
        if (res.is_success) {
            set_suggest_emails(res.data);
        }
    }
    const handleReloadEmailCoso = async () => {
        const res = await admissionHelperApi.dm_cauhinh_email_select_all();
        if (res.is_success) {
            set_suggest_coso_emails(res.data.filter((x: any) => x.dm_coso_id === dm_coso_id));
        }
    }
    const hanldeSubmit = async () => {
        SetIsSaving(true);
        const combinedEmails = [...email_to_send_when_finish, ...email_coso_to_send_when_finish].join(",");

        const res = await bienLaiThuApi.send_bienlai({
            sf_mucphaithu_id: props.sf_mucphaithu.id,
            email: combinedEmails,
            bcc_email: suggest_bcc_emails
        });

        if (res.is_success) {
            showNotify({ message: "Đã gửi email biên lai thu phí", type: "success" });
            props.onClose();
        } else {
            showNotify({ message: "Không gửi được biên lai", type: "warning" });
        }

        SetIsSaving(false);
    }

    return (
        <DefaultPopup title="Gửi thư xác nhận đến PHHS" onClose={props.onClose}>
            <div className="pop-up-form">
                <div className="col-md-12 padding-top-1em">
                    <h4>Chọn Email từ danh sách bên dưới hoặc điền email mới để gửi</h4>
                    <div className="margin-bottom-5">Gửi tới Email:</div>
                    <br />
                    <TagBox
                        items={suggest_emails}
                        showSelectionControls={true}
                        searchEnabled
                        displayExpr={'email'}
                        valueExpr={'email'}
                        value={email_to_send_when_finish}
                        multiline={true}
                        stylingMode="outlined"
                        width={'100%'}
                        showClearButton={true}
                        height={'auto'}
                        applyValueMode="useButtons"
                        acceptCustomValue={true}
                        onValueChanged={(e: any) => {
                            set_email_to_send_when_finish(e.value || []);
                        }}
                        onCustomItemCreating={(e: any) => {
                            const newItem = e.text.trim();
                            const lowerCasedNewValue = newItem.toLowerCase();
                            if (newItem && !suggest_emails.some((item: any) => item.email.toLowerCase() === lowerCasedNewValue)) {
                                const newEmail = { email: newItem };
                                set_suggest_emails([...suggest_emails, newEmail]);
                                e.customItem = new Promise(resolve => {
                                    resolve(newEmail);
                                });
                                set_email_to_send_when_finish([...email_to_send_when_finish, newEmail.email]);
                            }
                        }}
                    />
                    <br />
                    <div className="margin-bottom-5">Gửi tới Email (BCC):</div>
                    <br />
                    <TextBox value={suggest_bcc_emails}
                        stylingMode="outlined"
                        width={'100%'}
                        onValueChanged={(e) => {
                            set_suggest_bcc_emails(e.value)
                        }}
                    />
                    <br />
                    <CheckBox
                        value={isShowAttachEmail}
                        onValueChanged={() => SetIsShowAttachEmail(!isShowAttachEmail)}
                        text={'Đính kèm email trường'}
                    />
                    <br />
                    <br />

                    {isShowAttachEmail && <TagBox
                        items={suggest_coso_emails}
                        showSelectionControls={true}
                        searchEnabled
                        displayExpr={'email_from_address'}
                        valueExpr={'email_from_address'}
                        value={email_coso_to_send_when_finish}
                        multiline={true}
                        stylingMode="outlined"
                        width={'100%'}
                        showClearButton={true}
                        height={'auto'}
                        applyValueMode="useButtons"
                        acceptCustomValue={true}
                        onValueChanged={(e: any) => {
                            set_email_coso_to_send_when_finish(e.value || []);
                        }}
                        onCustomItemCreating={(e: any) => {
                            const newItem = e.text.trim();
                            const lowerCasedNewValue = newItem.toLowerCase();
                            if (newItem && !suggest_emails.some((item: any) => item.email.toLowerCase() === lowerCasedNewValue)) {
                                const newEmail = { email: newItem };
                                set_suggest_coso_emails([...suggest_coso_emails, newEmail]);
                                e.customItem = new Promise(resolve => {
                                    resolve(newEmail);
                                });
                                set_email_coso_to_send_when_finish([...email_coso_to_send_when_finish, newEmail.email]);
                            }
                        }}
                    />}
                </div>
            </div>
            <div className="pop-up-actions">
                <Button type="normal" text="Đóng" icon="fa fa-times" onClick={props.onClose} />{' '}
                <Button isLoading={isSaving} type="normal" icon="fas fa-check-square"
                    text="Gửi thư xác nhận" onClick={hanldeSubmit} />{' '}
            </div>
        </DefaultPopup>
    );
}

export default SendBienLaiModal;
